import React from "react"
// import { useDispatch, useSelector } from "react-redux"
import { useSelector } from "react-redux"
// import { SubscriptionButton } from "../../../common"
// import { setForm } from "../../../../redux/slices/signupSlice"
// import { GA_EVENTS } from "../../../../constants/analytics"
// import { FormattedMessage, useIntl } from "react-intl"
import { FormattedMessage } from "react-intl"

const Features = () => {
  const subscriptionType = useSelector((state) => state.signup.subscriptionType)

  // TODO: remove commented code after initial testing
  // const dispatch = useDispatch()
  // const { formatMessage } = useIntl()

  // const handleChooseASubscriptionClick = () => {
  //   window.scrollTo(0, 0)
  //   dispatch(setForm({ name: "subscriptionType", value: "Subscription" }))
  // }
  // const handleEnterpriseSolutionsClick = () => {
  //   window.scrollTo(0, 0)
  //   dispatch(setForm({ name: "subscriptionType", value: "Enterprise" }))
  // }

  return (
    <div className="features">
      <div className="features__wrapper">
        {subscriptionType === "Subscription" && (
          <div className="features__info">
            <p className="features__info-title">
              <FormattedMessage id="message.keepUsingSpareJobMatches" />
            </p>
          </div>
        )}

        <p className="features__title">
          <FormattedMessage id="message.everythingIncluded" />
        </p>

        <div className="features__cards">
          {FEATURES.map((card, index) => (
            <div key={`feature-card-${index}`} className="features__card">
              {card.svg}
              <p className="features__card-title">{card.title}</p>

              {card.texts.map((text, textIndex) => (
                <p
                  key={`feature-card-${index}-text-${textIndex}`}
                  className="features__card-text"
                >
                  {text}
                </p>
              ))}
            </div>
          ))}

          {/* TODO: Handle this behavior with new changes */}
          {/* {subscriptionType === "PayAsYouGo" && (
            <div className="features__card features__card--secondary">
              <p
                className={
                  "features__card-title features__card-title--secondary"
                }
              >
                <FormattedMessage id="common.needMore" />
              </p>

              <p className="features__card-text">
                <FormattedMessage id="message.twelveMonthSubscription" />
              </p>

              <p className="features__card-text features__card-text--secondary">
                <FormattedMessage id="message.saveUpTo35Percent" />
              </p>
              <p className="features__card-text features__card-text--secondary">
                <FormattedMessage id="message.firstWeekFree" />
              </p>
              <SubscriptionButton
                text={formatMessage({ id: "common.chooseSubscription" })}
                onClick={handleChooseASubscriptionClick}
                trackingEvent={{
                  ...GA_EVENTS.CHOOSE_PRICING.NEED_MORE_SELECTED,
                  label: formatMessage({ id: "common.chooseSubscription" }),
                }}
              />
            </div>
          )} */}

          {/* TODO: Handle this behavior with new changes */}
          {/* {subscriptionType === "Subscription" && (
            <div className="features__card features__card--secondary">
              <p
                className={
                  "features__card-title features__card-title--secondary"
                }
              >
                <FormattedMessage id="common.needMore" />
              </p>

              <p className="features__card-text">
                <FormattedMessage id="message.twelveMonthSubscription" />
              </p>
              <p className="features__card-text features__card-text--bold">
                <FormattedMessage id="message.seamlessIntegratedSolution" />
              </p>

              <SubscriptionButton
                text={formatMessage({ id: "common.enterpriseSolutions" })}
                onClick={handleEnterpriseSolutionsClick}
                trackingEvent={{
                  ...GA_EVENTS.CHOOSE_PRICING.NEED_MORE_SELECTED,
                  label: formatMessage({ id: "common.enterpriseSolutions" }),
                }}
              />
            </div>
          )} */}
        </div>
      </div>
    </div>
  )
}

const leadersSvg = (
  <svg
    width="47"
    height="47"
    viewBox="0 0 47 47"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M23.5 46C35.9264 46 46 35.9264 46 23.5C46 11.0736 35.9264 1 23.5 1C11.0736 1 1 11.0736 1 23.5C1 35.9264 11.0736 46 23.5 46Z"
      stroke="#3FA06E"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M33.04 13.96L28.27 28.27L13.96 33.04L18.73 18.73L33.04 13.96Z"
      stroke="#3FA06E"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

const proprietaryAndUnqiueAiTechnologiesSvg = (
  <svg
    width="48"
    height="47"
    viewBox="0 0 48 47"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.7392 12.7392H12.7627M44.6463 27.7888L27.8123 44.6228C27.3762 45.0594 26.8583 45.4058 26.2883 45.6421C25.7182 45.8784 25.1072 46 24.4901 46C23.873 46 23.262 45.8784 22.692 45.6421C22.1219 45.4058 21.604 45.0594 21.1679 44.6228L1 24.4784V1H24.4784L44.6463 21.1679C45.5209 22.0477 46.0118 23.2378 46.0118 24.4784C46.0118 25.7189 45.5209 26.909 44.6463 27.7888Z"
      stroke="#3FA06E"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

const awsCloudArchitectureSvg = (
  <svg
    width="57"
    height="47"
    viewBox="0 0 57 47"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.5111 36.0065L28.5046 46M28.5046 46L38.4981 36.0065M28.5046 46V23.5146M50.6902 38.7297C52.8623 37.2023 54.4912 35.0225 55.3404 32.5066C56.1897 29.9907 56.2152 27.2697 55.4132 24.7383C54.6112 22.207 53.0234 19.9971 50.8803 18.4293C48.7372 16.8614 46.1503 16.0173 43.4949 16.0194H40.3469C39.5955 13.091 38.1896 10.3712 36.2349 8.06476C34.2802 5.75833 31.8278 3.92539 29.0623 2.70391C26.2967 1.48244 23.2901 0.90426 20.2688 1.01291C17.2474 1.12157 14.2901 1.91421 11.6194 3.33119C8.94875 4.74816 6.63433 6.75253 4.85039 9.1934C3.06645 11.6343 1.85949 14.448 1.32036 17.4229C0.781232 20.3977 0.92399 23.4561 1.73789 26.3678C2.55178 29.2794 4.01561 31.9685 6.01917 34.2326"
      stroke="#3FA06E"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

const privateDataAreasSvg = (
  <svg
    width="50"
    height="47"
    viewBox="0 0 50 47"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M45.7797 1L41.0491 5.7306M41.0491 5.7306L48.145 12.8265L39.8664 21.1051L32.7705 14.0092M41.0491 5.7306L32.7705 14.0092M23.0491 23.7305C24.2704 24.9356 25.2413 26.3703 25.9058 27.9521C26.5704 29.5339 26.9155 31.2315 26.9212 32.9473C26.927 34.663 26.5933 36.3629 25.9393 37.9491C25.2854 39.5353 24.3242 40.9765 23.111 42.1897C21.8978 43.4029 20.4566 44.3641 18.8704 45.0181C17.2842 45.672 15.5842 46.0057 13.8685 45.9999C12.1528 45.9942 10.4552 45.6491 8.87339 44.9846C7.29159 44.32 5.85687 43.3492 4.65182 42.1279C2.2821 39.6743 0.970851 36.3882 1.00049 32.9772C1.03013 29.5663 2.39829 26.3034 4.81029 23.8914C7.2223 21.4794 10.4852 20.1112 13.8961 20.0816C17.3071 20.0519 20.5932 21.3632 23.0468 23.7329L23.0491 23.7305ZM23.0491 23.7305L32.7705 14.0092"
      stroke="#3FA06E"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

const integratedWorkflowSvg = (
  <svg
    width="52"
    height="47"
    viewBox="0 0 52 47"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16 46H36M26 36V46M6 1H46C48.7614 1 51 3.23858 51 6V31C51 33.7614 48.7614 36 46 36H6C3.23858 36 1 33.7614 1 31V6C1 3.23858 3.23858 1 6 1Z"
      stroke="#3FA06E"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

const jobMatchingSvg = (
  <svg
    width="57"
    height="47"
    viewBox="0 0 57 47"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M38.5 46V41C38.5 38.3478 37.4464 35.8043 35.5711 33.9289C33.6957 32.0536 31.1522 31 28.5 31H11C8.34784 31 5.8043 32.0536 3.92893 33.9289C2.05357 35.8043 1 38.3478 1 41V46M41.0036 21L46.0036 26L56.0036 16M29.7518 11C29.7518 16.5228 25.2746 21 19.7518 21C14.2289 21 9.75178 16.5228 9.75178 11C9.75178 5.47715 14.2289 1 19.7518 1C25.2746 1 29.7518 5.47715 29.7518 11Z"
      stroke="#3FA06E"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

const cvAnalysisSvg = (
  <svg
    width="47"
    height="47"
    viewBox="0 0 47 47"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 34.75L23.5 46L46 34.75M1 23.5L23.5 34.75L46 23.5M23.5 1L1 12.25L23.5 23.5L46 12.25L23.5 1Z"
      stroke="#3FA06E"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

const AIEnrichmentSvg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="-1 -1 45 45"
    id="Ai-Generate-Portrait-Image-Spark--Streamline-Core.svg"
    height="45" width="45"
  >
    <path id="Vector" stroke="#3fa06e" strokeLinecap="round" strokeLinejoin="round" d="M8.509607857142859 25.450778571428575c1.9601550000000003 -2.6239828571428574 5.090616428571429 -4.322697857142857 8.617814285714287 -4.322697857142857 2.5109235714285716 0 4.820791428571429 0.86086 6.650564285714285 2.303571428571429" strokeWidth="2"></path><path id="Vector_2" stroke="#3fa06e" strokeLinecap="round" strokeLinejoin="round" d="M15.591646428571428 32.64590714285715h-10.75c-0.8145735714285715 0 -1.5958221428571429 -0.3237285714285714 -2.171813285714286 -0.8996214285714286 -0.5760034285714286 -0.5758928571428572 -0.8995999285714287 -1.3572028571428572 -0.8995999285714287 -2.1717764285714285v-24.571428571428573c0 -0.8146042857142858 0.32359650000000006 -1.5958221428571429 0.8995999285714287 -2.1718409285714286 0.5759911428571429 -0.5760034285714286 1.3572397142857144 -0.8995999285714287 2.171813285714286 -0.8995999285714287h24.571428571428573c0.8146042857142858 0 1.5957607142857142 0.32359650000000006 2.1719607142857145 0.8995999285714287 0.5758928571428572 0.5760187857142858 0.8996214285714286 1.357236642857143 0.8996214285714286 2.1718409285714286v9.214285714285715" strokeWidth="2"></path><path id="Vector_3" stroke="#3fa06e" strokeLinecap="round" strokeLinejoin="round" d="M17.127360714285714 16.520937857142858c2.5444635714285715 0 4.607142857142858 -2.06271 4.607142857142858 -4.607142857142858 0 -2.5444635714285715 -2.0626792857142857 -4.607142857142858 -4.607142857142858 -4.607142857142858 -2.5444328571428576 0 -4.607142857142858 2.0626792857142857 -4.607142857142858 4.607142857142858 0 2.5444328571428576 2.06271 4.607142857142858 4.607142857142858 4.607142857142858Z" strokeWidth="2"></path><path id="Vector 2136" stroke="#3fa06e" strokeLinecap="round" strokeLinejoin="round" d="M22.542903571428575 32.44319285714286c-1.0778564285714287 -0.18766428571428573 -1.0778564285714287 -1.7349578571428572 0 -1.9224685714285716 3.904891428571429 -0.6793385714285715 7.010689285714286 -3.6536178571428577 7.858250000000001 -7.525460714285714l0.06496071428571429 -0.29679214285714284c0.23321357142857144 -1.0652635714285716 1.7501 -1.0718978571428572 1.9924357142857145 -0.008722857142857143l0.07893571428571429 0.34587357142857145c0.8790428571428572 3.853598571428572 3.9854857142857147 6.802722857142858 7.8797500000000005 7.480187857142858 1.0832928571428573 0.18846285714285715 1.0832928571428573 1.7437114285714286 0 1.932297142857143 -3.894264285714286 0.67725 -7.000707142857143 3.626435714285715 -7.8797500000000005 7.480157142857143l-0.07893571428571429 0.3458428571428572c-0.2423357142857143 1.0630214285714288 -1.759222142857143 1.0565714285714285 -1.9924357142857145 -0.008907142857142857l-0.06496071428571429 -0.2967c-0.8475607142857142 -3.871842857142857 -3.9533585714285717 -6.846214285714287 -7.858250000000001 -7.525307142857143Z" strokeWidth="2">
    </path>
  </svg>
);

const ManagementConsoleSvg = (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="-1 -1 45 45" id="Desktop-Check--Streamline-Core" height="45" width="45">
    <g id="desktop-check--success-approve-device-display-desktop-computer"><path id="Vector" stroke="#3fa06e" strokeLinecap="round" strokeLinejoin="round" d="M17.878478571428573 6.142857142857143H3.0714285714285716c-0.8481504285714286 0 -1.5357142857142858 0.68757 -1.5357142857142858 1.5357142857142858v24.571428571428573c0 0.8480214285714287 0.6875638571428572 1.5357142857142858 1.5357142857142858 1.5357142857142858h36.85714285714286c0.8480214285714287 0 1.5357142857142858 -0.6876928571428571 1.5357142857142858 -1.5357142857142858V17.159150000000004" strokeWidth="2"></path><path id="Vector_2" stroke="#3fa06e" strokeLinecap="round" strokeLinejoin="round" d="m18.42857142857143 33.785714285714285 -3.0714285714285716 7.678571428571429" strokeWidth="2"></path><path id="Vector_3" stroke="#3fa06e" strokeLinecap="round" strokeLinejoin="round" d="m24.571428571428573 33.785714285714285 3.0714285714285716 7.678571428571429" strokeWidth="2"></path><path id="Vector_4" stroke="#3fa06e" strokeLinecap="round" strokeLinejoin="round" d="M12.285714285714286 41.464285714285715h18.42857142857143" strokeWidth="2"></path><path id="Vector_5" stroke="#3fa06e" strokeLinecap="round" strokeLinejoin="round" d="m24.571428571428573 9.673187857142858 6.142857142857143 4.607142857142858L41.464285714285715 1.9946287142857146" strokeWidth="2"></path>
    </g>
  </svg>
);

// TODO: Apply translation to features
const FEATURES = [
  {
    title: <FormattedMessage id="feature.cvAnalysis.title" />,
    texts: [
      <FormattedMessage id="feature.cvAnalysis.text1" />,
      <FormattedMessage id="feature.cvAnalysis.text2" />,
    ],
    svg: cvAnalysisSvg,
  },
  {
    title: <FormattedMessage id="feature.aiEnrichment.title" />,
    texts: [
      <FormattedMessage id="feature.aiEnrichment.text1" />,
      <FormattedMessage id="feature.aiEnrichment.text2" />,
    ],
    svg: AIEnrichmentSvg,
  },
  {
    title: <FormattedMessage id="feature.jobMatching.title" />,
    texts: [
      <FormattedMessage id="feature.jobMatching.text1" />,
      <FormattedMessage id="feature.jobMatching.text2" />,
    ],
    svg: jobMatchingSvg,
  },
  
  
  {
    title: <FormattedMessage id="feature.integratedWorkflow.title" />,
    texts: [
      <FormattedMessage id="feature.integratedWorkflow.text1" />,
      <FormattedMessage id="feature.integratedWorkflow.text2" />,
    ],
    svg: integratedWorkflowSvg,
  },
  {
    title: <FormattedMessage id="feature.privateData.title" />,
    texts: [<FormattedMessage id="feature.privateData.text1" />],
    svg: privateDataAreasSvg,
  },
  {
    title: <FormattedMessage id="feature.managementConsole.title" />,
    texts: [
      <FormattedMessage id="feature.managementConsole.text1" />,
      <FormattedMessage id="feature.managementConsole.text2" />,
    ],
    svg: ManagementConsoleSvg,
  },


  {
    title: <FormattedMessage id="feature.cloudArchitecture.title" />,
    texts: [
      <FormattedMessage id="feature.cloudArchitecture.text1" />,
      <FormattedMessage id="feature.cloudArchitecture.text2" />,
      <FormattedMessage id="feature.cloudArchitecture.text3" />,
    ],
    svg: awsCloudArchitectureSvg,
  },
  {
    title: <FormattedMessage id="feature.proprietaryAI.title" />,
    texts: [
      <FormattedMessage id="feature.proprietaryAI.text1" />,
      <FormattedMessage id="feature.proprietaryAI.text2" />,
    ],
    svg: proprietaryAndUnqiueAiTechnologiesSvg,
  },
  {
    title: <FormattedMessage id="feature.trustworthy.title" />,
    texts: [
      <FormattedMessage id="feature.trustworthy.text1" />,
      <FormattedMessage id="feature.trustworthy.text2" />,
    ],
    svg: leadersSvg,
  },
]

export default Features
